/* * 卷帘 * @module components/contrastComponent/rollerContrast * @desc 用于展示对比 * @author sunsi *
@date 2020年8月13日 */
<template>
  <div class="rollerSplit">
    <div id="rollerMap">
      <div id="swipeContainer">
        <div id="swipeDiv">
          <div class="handle"></div>
        </div>
      </div>
    </div>
    <div class="treeIcon1" @mouseenter.stop="changeTree(1, true)">
      <img src="../../../../static/image/themeservice/layer.png" />
    </div>
    <div v-show="treeC1" class="tree1" @mouseleave.stop="changeTree(1, false)">
      <TreeContrast
        :mapdata="mapr"
        :isRoller="true"
        :rollerLeft="true"
        @rollerLeftLayer="rollerLeftLayer"
      ></TreeContrast>
    </div>
    <div class="treeIcon2" @mouseenter.stop="changeTree(2, true)">
      <img src="../../../../static/image/themeservice/layer.png" />
    </div>
    <div v-show="treeC2" class="tree2" @mouseleave.stop="changeTree(2, false)">
      <TreeContrast
        :mapdata="mapr"
        :isRoller="true"
        @removeRightLayer="removeRightLayer"
        @rollerRightLayer="rollerRightLayer"
      ></TreeContrast>
    </div>
    <!-- <input id="swipe" type="range" style="width: 100%" /> -->
  </div>
</template>
<script>
import rollerContrast from './rollerContrast';
export default rollerContrast;
</script>
<style lang="less" scoped>
.rollerSplit {
  height: 100%;
  border: 1px solid #dcdee2;
  #rollerMap {
    height: 100%;
    position: relative;
      #swipeContainer {
            position: absolute;
            opacity: 0.8;
            width: 0.625rem;
            height: 100%;
            /* margin: 0 auto; */
            top: 0;
            left: 50%;
            background-color: rgba(50, 50, 50, 0.75);
            cursor: col-resize;
            z-index: 2;
        }

        #swipeContainer:hover {
            opacity: 0.5;
        }

        #swipeDiv {
            border: solid 0.5px #ffffff;
            height: 100%;
            width: 0px;
            margin: 0 auto;
        }

        #swipeDiv .handle {
            width: 51px;
            height: 24px;
            margin-top: -12px;
            margin-left: -20px;
            top: 50%;
            left: 0;
            position: absolute;
            z-index: 30;
            font-family: "CalciteWebCoreIcons";
            speak: none;
            font-size: 12px;
            font-style: normal;
            font-weight: normal;
            font-variant: normal;
            text-transform: none;
            text-indent: 0;
            line-height: 1;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            background-color: black;
            color: white;
            opacity: 0.6;
        }

        *,
        *:before,
        *:after {
            -moz-box-sizing: border-box;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
        }

        .handle:before {
            margin: 0 18px 0 5px;
            content: "\0399\0399\0399";
            width: 20px;
            height: 24px;
            line-height: 2;
        }

        .handle:after {
            content: "\0399\0399\0399";
            width: 20px;
            height: 24px;
            line-height: 2;
        }
  }
}
.tree1 {
  position: absolute;
  width: 15%;
  left: 20px;
  top: 44px;
  height: 36%;
}

.treeIcon1 {
  position: absolute;
  left: 25px;
  top: 50px;
  width: 28px;
  height: 25px;
  background-color: #0099fa;
  // z-index: 9999;
  img {
    width: 100%;
    height: 100%;
  }
}
.treeIcon2 {
  position: absolute;
  right: 32px;
  top: 50px;
  width: 28px;
  height: 25px;
  background-color: #0099fa;
  // z-index: 9999;
  img {
    width: 100%;
    height: 100%;
  }
}
.tree2 {
  position: absolute;
  width: 15%;
  right: 0;
  top: 44px;
  height: 36%;
}
#swipe {
  // position: absolute;
  bottom: 0;
  right: 16px;
  z-index: 9999;
}
</style>



// WEBPACK FOOTER //
// src/components/contrastComponent/rollerContrast/rollerContrast.vue